import React from 'react'
import { Card, Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import BoardElementSelected from './BoardElementSelected';
import { ActionButton } from '@fluentui/react';
import { __enum_SystemPages, __SystemPagesPaths } from '../../../../../common/Dictionaries';
import '../../../../../styles/css/RelatedConcept.css'
import { useContext } from 'react';
import MainAppContext from '../../../../../MainAppContext';
import { __onGoToManageElement } from '../../../../../common/SystemRedirections';
import { useGetPrivilegeRoles } from '../../../../../hooks/services/sPrivilege/useOfPrivilege';
import { useState } from 'react';

function BoardElementsBox(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);

    //Parametros de entrada.
    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ? props.editMode : false;
    const inputParam_BoardId = props.boardId !== null && props.boardId !== undefined ? props.boardId : null;
    const inputParam_ElementList = props.elementList !== null && props.elementList !== undefined ? props.elementList : null;
    const inputParam_SetterBoardElementDeleted = props.setterBoardElementDeleted !== null && props.setterBoardElementDeleted !== undefined ? props.setterBoardElementDeleted : null;
    const inputParam_SetterBoardElementColor = props.setterBoardElementColor !== null && props.setterBoardElementColor !== undefined ? props.setterBoardElementColor : null;
    const inputParam_SetterStatusFly = props.setterStatusFly !== null && props.setterStatusFly !== undefined ? props.setterStatusFly : null;
    const boardElementDataserieUnsavedList = props.boardElementDataserieUnsavedList !== null && props.boardElementDataserieUnsavedList !== undefined ? props.boardElementDataserieUnsavedList : null;
    const setBoardElementDataserieUnsavedList = props.setBoardElementDataserieUnsavedList !== null && props.setBoardElementDataserieUnsavedList !== undefined ? props.setBoardElementDataserieUnsavedList : null;
    const inputParam_SetBoardElements = props.setBoardElements !== null && props.setBoardElements !== undefined ? props.setBoardElements : null;
    const inputParam_SetStatusFly = props.setStatusFly !== null && props.setStatusFly !== undefined ? props.setStatusFly : null;
    
    const [roleList, setRoleList] = useState(null);
    useGetPrivilegeRoles(roleList, setRoleList, true)

    return (
        <Card className='board-element-form'>
            <Row>
                <Col>
                    <Card.Header className="card-header-compact">
                        <Card.Title className="d-flex justify-content-between">
                            <b>{ t('data-lang-boxname-boardelements') }</b>
                            {
                                contextSite.securityProps.isAdmin &&
                                <div className='board-toolbar d-flex float-end'>
                                    <ActionButton iconProps={{ iconName: 'Settings' }} styles={{root: {height: "30px"}}} onClick={ __onGoToManageElement }>
                                        { t('data-lang-btn-setup') }
                                    </ActionButton>
                                </div>
                            }
                        </Card.Title>
                    </Card.Header>
                    <Card.Body className="board-element-form-body pt-2 w-100">
                        <Row className='h-100'>
                            {
                                roleList && inputParam_ElementList && inputParam_ElementList.map((element, index) => 
                                    <Col className={`mb-2`} key={ index } xs={12} sm={12} md={6} lg={6} xl={4} xxl={4}>
                                        <BoardElementSelected
                                            key={ index }
                                            inputParam_ElementItem={ element }
                                            inputParam_EditMode={ inputParam_EditMode }
                                            inputParam_BoardId={inputParam_BoardId}
                                            inputParam_SetterBoardElementDeleted={inputParam_SetterBoardElementDeleted}
                                            inputParam_SetterBoardElementColor={inputParam_SetterBoardElementColor}
                                            inputParam_SetterStatusFly={inputParam_SetterStatusFly}
                                            inputParam_ListElementColors={ inputParam_ElementList.map(x => x.htmlColor) }
                                            inputParam_TextIsDataLang={false}
                                            inputParam_BoardElementDataserieUnsavedList={boardElementDataserieUnsavedList}
                                            inputParam_SetBoardElementDataserieUnsavedList={setBoardElementDataserieUnsavedList}
                                            inputParam_RoleList={roleList}
                                            inputParam_ElementList={inputParam_ElementList}
                                            inputParam_SetBoardElements={inputParam_SetBoardElements}
                                            inputParam_SetStatusFly={inputParam_SetStatusFly}
                                        />
                                    </Col>
                                )
                            }
                        </Row>
                    </Card.Body>
                    <Card.Footer>
                    </Card.Footer>
                </Col>
            </Row>
        </Card>
    );
}

export default BoardElementsBox;